module.exports = __webpack_public_path__ + "img/header-7.ea7c57d4.png";